import { ChangeDetectionStrategy, ChangeDetectorRef, OnInit, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppSidebarNavComponent, INavData } from '@coreui/angular';
import { DxTextBoxComponent } from 'devextreme-angular';
import { AppComponent } from '../../app.component';
import { MenuService } from '../../menuService';
import { ResponseObject } from '../../models/response-object';
import { VwSchoolTerm } from '../../models/vw-school-term';
import { PaymentTypesService } from '../../services/payment-types-service';
import { UsersService } from '../../services/users-services/users-service';
import { VwClassesService } from '../../services/vw-classes-service';
import { VwLevelsService } from '../../services/vw-levels-service';
import { VwSchoolTermsService } from '../../services/vw-school-terms-service';
import { DialogMessageTypes, MessageDialogComponent } from '../../views/common/message-dialog/message-dialog.component';
import { ProcessingDialogComponent } from '../../views/common/processing-dialog/processing-dialog.component';
import { ResponseStatus } from '../../views/enums/response-statuses';
import { UserAuthenticationResponce } from '../../views/login/login.component';
import { NotificationsService } from 'angular2-notifications';
import { LessonStatusService } from '../../services/timetable-services/lesson-status-service';
import { SPControllerService } from '../../services/student-portal/sp-controller-service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [LessonStatusService]
})

export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  navItems;

  @ViewChild(AppSidebarNavComponent, { static: true }) menu: AppSidebarNavComponent;

  isLogOutPopupVisible: Boolean = false;
  record;
  levels = this.levelsService.oDataSource;
  paymentTypes = this.paymentTypesService.oDataSource;
  classes = this.classesService.oDataSource;
  terms: VwSchoolTerm[] = [];
  menuOptions: MenuOptions[] = []
  paletteCollection = ["Material", "Soft Pastel", "Harmony Light", "Pastel", "Bright", "Soft", "Ocean", "Office", "Vintage", "Violet", "Carmine", "Dark Moon", "Soft Blue", "Dark Violet", "Green Mist"];
  palette = sessionStorage.getItem("GraphPalette");
  data: DataItem[] = this.getData();
  isUserOptionsPopupVisible: Boolean = false;
  isChangePasswordPopupVisible: Boolean = false;
  passwordRecoveryOptions = [{ "Option": "Email" }, { "Option": "SMS" }];
  scannerOptions = [{ "Option": "Barcode Scanner" }, { "Option": "Both" }, { "Option": "Camera" }, { "Option": "None" }];
  commentSourceOptions=[{"Option":"Private Comments Bank"},{"Option":"Private And Public Comments Bank"}];
  changePasswordDetails: ChangePasswordDetails = new ChangePasswordDetails();
  passwordMode: String = "password";
  passwordButton: any;
  newPasswordButton: any;
  newPasswordMode: String = "password";
  @ViewChild("txtCurrentPassword", { static: true }) txtCurrentPassword: DxTextBoxComponent;
  @ViewChild("txtNewPassword", { static: true }) txtNewPassword: DxTextBoxComponent;
  @ViewChild("txtStudentCurrentPassword", { static: true }) txtStudentCurrentPassword: DxTextBoxComponent;
  @ViewChild("txtStudentNewPassword", { static: true }) txtStudentNewPassword: DxTextBoxComponent;
  @ViewChild(MessageDialogComponent, { static: true }) messageDialog: MessageDialogComponent;
  @ViewChild(ProcessingDialogComponent, { static: true }) processingDialog: ProcessingDialogComponent;
  userOptionsDetails: UserOptions = new UserOptions();
  licenseExpiryDate: String = sessionStorage.getItem("LicenseExpiryDate");
  licenseDaysLeft: String = sessionStorage.getItem("LicenseDaysLeft");
  licensedStudentsBalance: String = sessionStorage.getItem("LicensedStudentsBalance");
  unLicensedStudentBalance: String = sessionStorage.getItem("UnLicensedStudentsBalance");
  passwordExpiryDate: String = sessionStorage.getItem("PasswordExpiryDate");
  refreshTimer;
  uncomingLessonMessages: Messages[] = [];
  mainSystem: Boolean = false;
  studentPortal: Boolean = false;
  studentName: String = "";
  appRightMenuMinimised = false;
  isStudentChangePasswordPopupVisible: Boolean = false;

  ngOnInit(): void {
    this.sidebarMinimized = true;
    if (sessionStorage.getItem("GUID") == "DBB7A467-FFFA-4C3B-81BB-C7E4E2EEF22B") {
      this.mainSystem = true;
    }
    else if (sessionStorage.getItem("GUID") == "F570BDF4-4A2F-4F8F-AEA9-518011009B1D") {
      this.studentPortal = true;
      this.sidebarMinimized = false;
      this.appRightMenuMinimised = true;
      this.studentName = sessionStorage.getItem("StudentNumber") + " " + sessionStorage.getItem("StudentName");
    }
    this.refreshTimer = setInterval(() => {
      this.refreshData();
    }, 60000);
  }

  constructor(private router: Router,
    private notificationService: NotificationsService,
    private levelsService: VwLevelsService,
    private usersService: UsersService,
    private lessonStatusService: LessonStatusService,
    private myapp: AppComponent,
    private menuService: MenuService,
    private controllerService: SPControllerService,
    private paymentTypesService: PaymentTypesService,
    private classesService: VwClassesService,
    private cdRef: ChangeDetectorRef,
    private termsService: VwSchoolTermsService) {
    this.passwordButton = {
      icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVRYw+2YP0tcQRTFz65xFVJZpBBS2O2qVSrRUkwqYfUDpBbWQu3ELt/HLRQ/Q8RCGxVJrRDEwj9sTATxZ/Hugo4zL/NmV1xhD9xi59177pl9986fVwLUSyi/tYC+oL6gbuNDYtyUpLqkaUmfJY3a+G9JZ5J2JW1J2ivMDBSxeWCfeBxYTHSOWMcRYLOAEBebxtEVQWPASQdi2jgxro4E1YDTQIJjYM18hszGbew4EHNq/kmCvgDnHtI7YBko58SWgSXg1hN/btyFBM0AlwExczG1YDZrMS4uLUeUoDmgFfjLGwXEtG05wNXyTc4NXgzMCOAIGHD8q0ATuDZrempkwGJ9+AfUQ4K+A/eEseqZ/UbgdUw4fqs5vPeW+5mgBvBAPkLd8cPju+341P7D/WAaJGCdOFQI14kr6o/zvBKZYz11L5Okv5KGA89Kzu9K0b0s5ZXt5PjuOL6TRV5ZalFP4F+rrnhZ1Cs5vN6ijmn7Q162/ThZq9+YNW3MbfvDAOed5cxdGL+RFaUPKQtjI8DVAr66/u9i6+jJzTXm+HFEVqxVYBD4SNZNKzk109HxoycPaG0bIeugVDTp4hH2qdXJDu6xOAAWiuQoQdLHhvY1aEZSVdInG7+Q9EvSz9RrUKqgV0PP3Vz7gvqCOsUj+CxC9LB1Dc8AAAASdEVYdEVYSUY6T3JpZW50YXRpb24AMYRY7O8AAAAASUVORK5CYII=",
      type: "default",
      onClick: () => {
        this.passwordMode = this.passwordMode === "text" ? "password" : "text";
      }
    };
    this.newPasswordButton = {
      icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVRYw+2YP0tcQRTFz65xFVJZpBBS2O2qVSrRUkwqYfUDpBbWQu3ELt/HLRQ/Q8RCGxVJrRDEwj9sTATxZ/Hugo4zL/NmV1xhD9xi59177pl9986fVwLUSyi/tYC+oL6gbuNDYtyUpLqkaUmfJY3a+G9JZ5J2JW1J2ivMDBSxeWCfeBxYTHSOWMcRYLOAEBebxtEVQWPASQdi2jgxro4E1YDTQIJjYM18hszGbew4EHNq/kmCvgDnHtI7YBko58SWgSXg1hN/btyFBM0AlwExczG1YDZrMS4uLUeUoDmgFfjLGwXEtG05wNXyTc4NXgzMCOAIGHD8q0ATuDZrempkwGJ9+AfUQ4K+A/eEseqZ/UbgdUw4fqs5vPeW+5mgBvBAPkLd8cPju+341P7D/WAaJGCdOFQI14kr6o/zvBKZYz11L5Okv5KGA89Kzu9K0b0s5ZXt5PjuOL6TRV5ZalFP4F+rrnhZ1Cs5vN6ijmn7Q162/ThZq9+YNW3MbfvDAOed5cxdGL+RFaUPKQtjI8DVAr66/u9i6+jJzTXm+HFEVqxVYBD4SNZNKzk109HxoycPaG0bIeugVDTp4hH2qdXJDu6xOAAWiuQoQdLHhvY1aEZSVdInG7+Q9EvSz9RrUKqgV0PP3Vz7gvqCOsUj+CxC9LB1Dc8AAAASdEVYdEVYSUY6T3JpZW50YXRpb24AMYRY7O8AAAAASUVORK5CYII=",
      type: "default",
      onClick: () => {
        this.newPasswordMode = this.newPasswordMode === "text" ? "password" : "text";
      }
    };
  }


  ngOnDestroy() {
    clearInterval(this.refreshTimer);
  }

  refreshData() {
    if (sessionStorage.getItem("GUID") == "DBB7A467-FFFA-4C3B-81BB-C7E4E2EEF22B") { //Main System
      this.lessonStatusService.utilitiesGet("/GetMessages?teacherID=" + sessionStorage.getItem("TeacherID") + "&username=" + sessionStorage.getItem("Username")).subscribe(
        data => {
          this.uncomingLessonMessages = data;
          for (let message of this.uncomingLessonMessages) {
            if (message.MessageType == "Information") {
              this.notificationService.info(message.MessageTitle, message.Message.toString(), {
                position: ['bottom', 'right'],
                timeOut: 40000,
                animate: true,
                showProgressBar: true,
                pauseOnHover: true,
                clickToClose: true,
                clickIconToClose: true
              })
            }
            else if (message.MessageType == "Error") {
              this.notificationService.error(message.MessageTitle, message.Message.toString(), {
                position: ['bottom', 'right'],
                timeOut: 40000,
                animate: true,
                showProgressBar: true,
                pauseOnHover: true,
                clickToClose: true,
                clickIconToClose: true
              })
            }
            else if (message.MessageType == "Success") {
              this.notificationService.success(message.MessageTitle, message.Message.toString(), {
                position: ['bottom', 'right'],
                timeOut: 40000,
                animate: true,
                showProgressBar: true,
                pauseOnHover: true,
                clickToClose: true,
                clickIconToClose: true
              })
            }
            else if (message.MessageType == "Warning") {
              this.notificationService.warn(message.MessageTitle, message.Message.toString(), {
                position: ['bottom', 'right'],
                timeOut: 40000,
                animate: true,
                showProgressBar: true,
                pauseOnHover: true,
                clickToClose: true,
                clickIconToClose: true
              })
            }
            let audio = new Audio();
            audio.src = "../../../assets/sounds/notification-alert.wav";
            audio.load();
            audio.play();
          }
        }
      )
    }
  }

  ngAfterViewInit() {
    this.myapp.getMenu();
    this.navItems = this.menuService.items;
    this.cdRef.detectChanges();
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }


  changePasswordClick() {
    if (this.mainSystem == true) {
      this.changePasswordDetails = new ChangePasswordDetails();
      this.changePasswordDetails.Username = sessionStorage.getItem("Username");
      this.changePasswordDetails.FullName = sessionStorage.getItem("FullName");
      this.txtCurrentPassword.value = "";
      this.txtNewPassword.value = "";
      this.isChangePasswordPopupVisible = true;
    }
    else if (this.studentPortal == true) {
      this.changePasswordDetails = new ChangePasswordDetails();
      this.changePasswordDetails.Username = sessionStorage.getItem("StudentNumber");
      this.changePasswordDetails.FullName = sessionStorage.getItem("StudentName");
      this.txtStudentCurrentPassword.value = "";
      this.txtStudentNewPassword.value = "";
      this.isStudentChangePasswordPopupVisible = true;
    }
  }

  studentChangePasswordCloseClick() {
    this.isStudentChangePasswordPopupVisible = false;
  }

  studentChangePasswordSaveClick() {
    this.changePasswordDetails.CurrentPassword = this.txtStudentCurrentPassword.value;
    this.changePasswordDetails.NewPassword = this.txtStudentNewPassword.value;
    if (this.changePasswordDetails.PasswordHint == undefined) {
      this.changePasswordDetails.PasswordHint = "";
    }
    if (this.changePasswordDetails.NewPassword == this.changePasswordDetails.CurrentPassword) {
      this.messageDialog.show("New password must be diferent from current password.", DialogMessageTypes.Information);
    }
    else {
      this.processingDialog.show();
      this.controllerService.utilitiesGet("StudentAuthentication/ChangePassword?studentNumber=" + this.changePasswordDetails.Username + "&password=" + this.changePasswordDetails.CurrentPassword + "&newPassword=" + this.changePasswordDetails.NewPassword + "&save=true").subscribe(
        data => {
          this.processingDialog.hide();
          let responce: ResponseObject = data;
          if (responce.Status == ResponseStatus.Success) {
            sessionStorage.setItem("PasswordExpiryDate", responce.StatusDescription.toString());
            this.isStudentChangePasswordPopupVisible = false;
            this.messageDialog.show("Password has been successfully changed.", DialogMessageTypes.Information);
          }
          else if (responce.Status == ResponseStatus.Failure) {
            this.messageDialog.show(responce.StatusDescription, DialogMessageTypes.Information);
          }
          else {
            this.messageDialog.show("A system error was encountered trying to change the password.", DialogMessageTypes.SystemError);
          }
        },
        error => {
          this.processingDialog.hide();
          this.messageDialog.show("A system error was encountered trying to change the password.", DialogMessageTypes.SystemError);
        }
      )
    }
  }

  userOptionsClick() {
    let x = JSON.parse(sessionStorage.getItem("UserMenu"));
    this.userOptionsDetails = new UserOptions();
    this.terms = [];
    this.processingDialog.show();
    this.termsService.searchNonOdata("/VwSchoolTerms?$filter= Years le " + sessionStorage.getItem("TermYears").valueOf()).subscribe(
      data => {
        this.processingDialog.hide();
        this.terms = data.value;
        let currentTerm: VwSchoolTerm = new VwSchoolTerm();
        currentTerm.ID = 0;
        currentTerm.TermName = "Use Current Term";
        this.terms.push(currentTerm);
        this.userOptionsDetails.Username = sessionStorage.getItem("Username");
        this.userOptionsDetails.DefaultTermID = +sessionStorage.getItem("DefaultTermID");
        this.userOptionsDetails.DefaultLevelID = +sessionStorage.getItem("DefaultLevelID");
        this.userOptionsDetails.DefaultClassID = +sessionStorage.getItem("DefaultClassID");
        this.userOptionsDetails.DefaultPaymentType = sessionStorage.getItem("DefaultPaymentType");
        this.userOptionsDetails.TermYears = +sessionStorage.getItem("TermYears");
        this.userOptionsDetails.PreferredScanner = sessionStorage.getItem("PreferredScanner");
        this.userOptionsDetails.PasswordRecoveryOption = sessionStorage.getItem("PasswordRecoveryOption");
        this.userOptionsDetails.CommentsSource = sessionStorage.getItem("CommentsSource");
        this.isUserOptionsPopupVisible = true;
      },
      error => {
        this.processingDialog.hide();
        this.messageDialog.show("A system error was encountered trying to process the request.", DialogMessageTypes.SystemError);
      }
    );
  }

  userOptionsSaveClick() {
    this.processingDialog.show();
    this.usersService.utilitiesGet("UpdateUserOptions?username=" + this.userOptionsDetails.Username + "&defaultLevelID=" + this.userOptionsDetails.DefaultLevelID + "&defaultClassID=" + this.userOptionsDetails.DefaultClassID + "&defaultTermID=" + this.userOptionsDetails.DefaultTermID + "&defaultPaymentType=" + this.userOptionsDetails.DefaultPaymentType + "&termYears=" + this.userOptionsDetails.TermYears + "&passwordRecoveryOption=" + this.userOptionsDetails.PasswordRecoveryOption + "&graphPallete=" + this.palette + "&scanner=" + this.userOptionsDetails.PreferredScanner + "&commentsSource=" + this.userOptionsDetails.CommentsSource).subscribe(
      data => {
        this.processingDialog.hide();
        let authenticationResponce: UserAuthenticationResponce = data;
        let response: ResponseObject = authenticationResponce.Response;
        if (response.Status == ResponseStatus.Success) {
          sessionStorage.setItem("DefaultLevelName", authenticationResponce.UserDetails.DefaultLevel.toString());
          sessionStorage.setItem("DefaultLevelID", authenticationResponce.UserDetails.DefaultLevelID.toString());
          sessionStorage.setItem("DefaultTermID", authenticationResponce.UserDetails.DefaultTermID.toString());
          sessionStorage.setItem("DefaultTermName", authenticationResponce.UserDetails.DefaultTerm.toString());
          sessionStorage.setItem("DefaultClassID", authenticationResponce.UserDetails.DefaultClassID.toString());
          sessionStorage.setItem("DefaultClass", authenticationResponce.UserDetails.DefaultClass.toString());
          sessionStorage.setItem("DefaultPaymentType", authenticationResponce.UserDetails.DefaultPaymentType.toString());
          sessionStorage.setItem("TermYears", authenticationResponce.UserDetails.TermYears.toString());
          sessionStorage.setItem("CommentsSource", authenticationResponce.UserDetails.CommentsSource.toString());
          sessionStorage.setItem("GraphPalette", authenticationResponce.UserDetails.GraphPallete.toString());
          sessionStorage.setItem("PreferredScanner", authenticationResponce.UserDetails.PreferredScanner.toString());
          sessionStorage.setItem("PasswordRecoveryOption", authenticationResponce.UserDetails.PasswordRecoveryOption.toString());
          this.isUserOptionsPopupVisible = false;
          this.messageDialog.show("User options have been updated.", DialogMessageTypes.Information);
        }
        else if (response.Status == ResponseStatus.Failure) {
          this.messageDialog.show(response.StatusDescription, DialogMessageTypes.Information);
        }
        else {
          this.messageDialog.show("A system error was encountered trying to process the request.", DialogMessageTypes.SystemError);
        }
      },
      error => {
        this.processingDialog.hide();
        this.messageDialog.show("A system error was encountered trying to process the request.", DialogMessageTypes.SystemError);
      }
    )
  }

  userOptionsCloseClick() {
    this.isUserOptionsPopupVisible = false;
  }

  changePasswordCloseClick() {
    this.isChangePasswordPopupVisible = false;
  }

  changePasswordSaveClick() {
    this.changePasswordDetails.CurrentPassword = this.txtCurrentPassword.value;
    this.changePasswordDetails.NewPassword = this.txtNewPassword.value;
    if (this.changePasswordDetails.PasswordHint == undefined) {
      this.changePasswordDetails.PasswordHint = "";
    }
    if (this.changePasswordDetails.NewPassword == this.changePasswordDetails.CurrentPassword) {
      this.messageDialog.show("New password must be diferent from current password.", DialogMessageTypes.Information);
    }
    else {
      this.processingDialog.show();
      this.usersService.utilitiesGet("/ChangePassword?username=" + this.changePasswordDetails.Username + "&password=" + this.changePasswordDetails.CurrentPassword + "&newPassword=" + this.changePasswordDetails.NewPassword + "&passwordHint=" + this.changePasswordDetails.PasswordHint).subscribe(
        data => {
          this.processingDialog.hide();
          let responce: ResponseObject = data;
          if (responce.Status == ResponseStatus.Success) {
            sessionStorage.setItem("PasswordExpiryDate", responce.StatusDescription.toString());
            this.isChangePasswordPopupVisible = false;
            this.messageDialog.show("Password has been successfully changed.", DialogMessageTypes.Information);
          }
          else if (responce.Status == ResponseStatus.Failure) {
            this.messageDialog.show(responce.StatusDescription, DialogMessageTypes.Information);
          }
          else {
            this.messageDialog.show("A system error was encountered trying to change the password.", DialogMessageTypes.SystemError);
          }
        },
        error => {
          this.processingDialog.hide();
          this.messageDialog.show("A system error was encountered trying to change the password.", DialogMessageTypes.SystemError);
        }
      )
    }
  }

  logOutClick() {
    this.isLogOutPopupVisible = true;
  }

  closeConfirmLogOutClick() {
    this.isLogOutPopupVisible = false;
  }

  confirmLogoutClick() {
    if (this.mainSystem == true) {
      this.usersService.utilitiesGet("/LogOut?username=" + sessionStorage.getItem("Username") + "&type=User&save=true&save1=true&save2=true&save3=true&save4=true&save5=true").subscribe();
    }
    this.isLogOutPopupVisible = false;
    sessionStorage.clear();
    this.router.navigate(['/', 'login']);
  }

  getData(): DataItem[] {
    return new Array(10).fill(1).map((val, index) => {
      return {
        arg: "Item" + index,
        val: val
      }
    });
  }
}

class DataItem {
  arg: string;
  val: number;
}

class MenuOptions {
  public id: number;
  public parentId: number;
  public text: string;
  public icon: string;
}

class ChangePasswordDetails {
  public Username: String;
  public FullName: String;
  public NewPassword: String;
  public CurrentPassword: String;
  public PasswordHint: String;
}

class UserOptions {
  public Username: String;
  public DefaultLevelID: Number;
  public DefaultClassID: Number;
  public DefaultTermID: Number;
  public DefaultPaymentType: String;
  public PasswordRecoveryOption: String;
  public TermYears: Number;
  public PreferredScanner: String;
  public CommentsSource:String;
}

class Messages {
  public Message: String;
  public MessageType: String;
  public MessageTitle: String;
}


